let axios = require('axios')

let instance = axios.create({
  baseURL: process.env.VUE_APP_API_HOST || 'http://localhost:3034',
  withCredentials: true
})



module.exports = instance